import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'sessionStaffingFilterBySearch' })
export class SessionStaffingSearchPipe implements PipeTransform {
    transform(sessions: any[], search: string): any[] {
        if (sessions === undefined || search === '') {
            return sessions;
        }
        return sessions.filter((session) => {
            if (session.title.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (
                session.estimationDate
                    .toLowerCase()
                    .includes(search.toLowerCase())
            ) {
                return true;
            } else if (
                session.message.toLowerCase().includes(search.toLowerCase())
            ) {
                return true;
            }
            return false;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/staffing/pipe/search.pipe.ts